<template>
  <el-config-provider :locale="elLocale">
    <div id="app">
      <router-view v-if="appReady" />
      <div v-else class="loading-container">
        <!-- 加载指示器 -->
        <el-loading 
          v-loading="!appReady" 
          :text="$t('app.loading')" 
          :background="'rgba(255, 255, 255, 0.8)'"
          class="loading-indicator"
        >
        </el-loading>
      </div>
    </div>
  </el-config-provider>
</template>

<script setup>
import { ref, watch, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'
import { ElConfigProvider, ElLoading } from 'element-plus'
import { loadElementLocale } from '@/utils/locale'

const { locale  } = useI18n()
const elLocale = ref()
const appReady = ref(false)

// 初始化应用
const initApp = async () => {
  try {
    // 1. 加载Element Plus语言包
    elLocale.value = await loadElementLocale(locale.value)
    
    // 2. 模拟其他初始化逻辑（如权限校验、数据预加载等）
    await new Promise(resolve => setTimeout(resolve, 500))
    
    appReady.value = true
  } catch (error) {
    console.error('应用初始化失败:', error)
    // 错误处理：显示错误提示
    //ElMessage.error(t('app.initFailed'))
  }
}

// 监听语言变化
watch(locale, async (newVal) => {
  elLocale.value = await loadElementLocale(newVal)
})

onMounted(() => {
  initApp()
})
</script>

<style>
/* 重置基础样式 */
html, body {
  margin: 0;
  padding: 0;
  height: 100vh;
  overflow: hidden; /* 防止根元素滚动 */
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  height: 100vh;
  overflow: hidden; /* 防止应用容器滚动 */  
}

.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

.loading-indicator {
  width: 100%;
  height: 100%;
}

/* 确保Element Plus弹窗不受容器影响 */
.el-overlay {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
}

/* 当有弹窗时，body不滚动 */
body.el-popup-parent--hidden {
  overflow: hidden !important;
}
</style>